import React from "react";

import Act from "./componets/act/act.component";

import "./App.css";

function App() {
  return (
    <div className="app">
      <Act />
    </div>
  );
}

export default App;
